import { get, post, patch, del } from "@insite/client-framework/Services/ApiService";

export interface AddOrUpdateBranchApiModel {
    id?: string;
    name: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    zipCode: string;
}

export interface BrandsModel {
    id: string;
    name: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    zipCode: string;
}

export interface BrandsCollectionModel {
    uri?: string;
    brandsList: BrandsModel[];
    properties?: any;
    pagination?: {
        currentPage: number;
        page: number;
        pageSize: number;
        totalItemCount: number;
        numberOfPages: number;
    };
}

export interface DeleteBrandModel {
    id: string;
    success: boolean;
}

const baseUrl = "/api/v2/centroconnect/sme/admin/smebrands";
// const collectionUrl = `${baseUrl}?page=1&pageSize=50`;

export function addBrands(model: AddOrUpdateBranchApiModel) {
    return post<AddOrUpdateBranchApiModel, BrandsModel>(baseUrl, model as any);
}

export function getBrandsCollection(page?: number, pageSize?: number) {
    const params = new URLSearchParams();
    if (page !== undefined) {
        params.append('page', page.toString());
    }
    if (pageSize !== undefined) {
        params.append('pageSize', pageSize.toString());
    }
    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    return get<BrandsCollectionModel>(url);
}

export function updateBrands(model: AddOrUpdateBranchApiModel) {
    return patch<any>(baseUrl, model as any) as Promise<BrandsModel>;
}

export function deleteBrands(branchId: string) {
    return del(`${baseUrl}/${branchId}`) as Promise<void>;
}
